import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  computed,
  inject,
  input,
  output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { StateIndicator, BadgeCopyComponent } from '@ui';
import { IndicatorState } from '../../../models/indicator.models';
import { IndicatorStates } from '../../../constants/indicators.constants';

@Component({
  selector: 'ui-losses-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoDirective,
    BadgeCopyComponent
],
  template: `
    <ng-container *transloco="let t">
      <div [class]="states?.[state()]?.label" class="h-5 max-w-[85%] text-ellipsis whitespace-nowrap overflow-hidden">
        <span
          class="text-xs font-medium uppercase transition-colors duration-300"
          (click)="emitCenter()"
        >
          {{ centerName() }}
        </span>
      </div>
      <ui-badge-copy [id]="centerId()!" [disabled]="isDisabled()" />
    </ng-container>
  `,
})
export class LossesIndicatorComponent implements AfterViewInit {
  private cdr = inject(ChangeDetectorRef);

  centerName = input.required<string>();
  distributorId = input.required<string>();
  centerId = input.required<string>();
  rsabtId = input.required<string>();
  tsabtId = input.required<string>();
  vtnId = input.required<string>();
  state = input<IndicatorState>(IndicatorStates.Default);
  indicators = input<string[]>([]);
  onRsabt = output<string>();

  onCenter = output<{
    distributorId: string;
    centerId: string;
    rsabtId: string;
    tsabtId: string;
    vtnId: string;
  }>();

  isDisabled = computed<boolean>(
    () => this.state() === IndicatorStates.Disabled,
  );

  @ViewChild('transformerIconTemplate')
  transformerIconTemplate!: TemplateRef<any>;
  @ViewChild('transformerIconDisabledTemplate')
  transformerIconDisabledTemplate!: TemplateRef<any>;

  states!: StateIndicator | undefined;

  ngAfterViewInit(): void {
    this.states = {
      active: {
        content: this.transformerIconTemplate,
        label: 'cursor-pointer text-primary hover:text-tertiary',
      },
      disabled: {
        content: this.transformerIconDisabledTemplate,
        label: 'text-neutral-6',
      },
    };
    this.cdr.detectChanges();
  }

  emitCenter() {
    this.onCenter.emit({
      distributorId: this.distributorId()!,
      centerId: this.centerId()!,
      rsabtId: this.rsabtId()!,
      tsabtId: this.tsabtId()!,
      vtnId: this.vtnId()!,
    });
  }

  emitRsabt(id: string) {
    this.onRsabt.emit(id);
  }
}
